import React, { FC, useEffect, useMemo, useState } from 'react';
import { Button, Modal, EchartsWithTheme, useTheme } from '@maxtropy/components';
import { Empty, Skeleton } from 'antd';
import dayjs from 'dayjs';
import { DeviationAlarmRecordItem } from '../../service';
import { apiV2EnergyCompareGetMediumIndicatorLossHourlyDataPost } from '../../service';
import { getDeviationDetailChartOption } from './chartOptions';
import {
  apiV2EnergyCompareGetMediumIndicatorLossDataPost,
  V2EnergyCompareGetMediumIndicatorLossDataPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { CycleType } from '@/pages/DeviationAlarmConfig/service';

export interface IDetailModal {
  visible: boolean;
  record?: DeviationAlarmRecordItem;
  onClose: () => void;
}

const DetailModal: FC<IDetailModal> = props => {
  const { visible, record, onClose } = props;
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<V2EnergyCompareGetMediumIndicatorLossDataPostResponse>();

  useEffect(() => {
    if (visible && record) {
      setLoading(true);
      // 判断是否按小时
      const isHourly = record.statCycleType === CycleType.hour;

      const params = {
        processId: Number(record.energyMediumTopologyNodeId),
        energyMediumId: Number(record.energyMediumId),
        from: dayjs(record.statCycleFromTime).valueOf(),
        to: dayjs(record.statCycleToTime).valueOf(),
        timeResolution: isHourly ? 'H' : 'D',
      };

      const request = isHourly
        ? apiV2EnergyCompareGetMediumIndicatorLossHourlyDataPost(params)
        : apiV2EnergyCompareGetMediumIndicatorLossDataPost(params);

      request
        .then(res => {
          setChartData(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [visible, record]);

  const chartOption = useMemo(() => {
    if (!chartData?.viewVoTos?.[0]) return null;
    return getDeviationDetailChartOption(
      chartData.viewVoTos[0],
      record?.physicalUnitName,
      record?.statCycleFromTime,
      record?.statCycleToTime,
      record?.statCycleType
    );
  }, [chartData, record]);

  // 格式化时间范围
  const formatTimeRange = () => {
    if (record?.statCycleFromTime && record?.statCycleToTime) {
      const isHourly = record.statCycleType === CycleType.hour;
      const format = isHourly ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      return `${dayjs(record.statCycleFromTime).format(format)} ~ ${dayjs(record.statCycleToTime).format(format)}`;
    }
    return '--';
  };

  return (
    <Modal
      title="查看详情"
      open={visible}
      onCancel={onClose}
      width={900}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 16 }}>时间范围: {formatTimeRange()}</div>

      <Skeleton loading={loading} paragraph={{ rows: 6 }}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !chartOption,
            emptyNode: <Empty style={{ height: 400 }} />,
          }}
          option={chartOption || {}}
          style={{ height: 400 }}
          theme={theme}
        />
      </Skeleton>
    </Modal>
  );
};

export default DetailModal;
